
import Vue from 'vue';

import { faFacebookF, faInstagram, faLinkedinIn, faTwitter } from '@delfi.lt/fa-kit/icons/modules/classic/brands';

interface Computed {
  sharingLinks: {
    facebook: {
      enabled: boolean;
      href: string;
    };
    twitter: {
      enabled: boolean;
      href: string;
    };
    instagram: {
      enabled: boolean;
      href: string;
    };
    vk: {
      enabled: boolean;
      href: string;
    };
  };
}

export default Vue.extend<unknown, unknown, Computed, unknown>({
  data() {
    return {
      faFacebookF,
      faInstagram,
      faLinkedinIn,
      faTwitter,
    };
  },
  computed: {
    sharingLinks() {
      return this.$channelConfig('socialLinks');
    },
  },
});
